import { render, staticRenderFns } from "./GoalList.vue?vue&type=template&id=298cf072&scoped=true&"
import script from "./GoalList.vue?vue&type=script&lang=js&"
export * from "./GoalList.vue?vue&type=script&lang=js&"
import style0 from "./GoalList.vue?vue&type=style&index=0&id=298cf072&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298cf072",
  null
  
)

export default component.exports